<!-- 召回通知单列表 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="400px">
            <creditApplyAction v-if="showStatus" ref="creditApplyAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></creditApplyAction>
        </el-drawer>
        <subComponents ref="showSelectData"></subComponents>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <vSearch @searchData="searchData" @openSearchs="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
                </vSearch>
            </div>
        </div>
        <div class="page_content_center">
            <el-table ref="elTable" @selection-change="handleSelectionChange" size="mini" v-if="pageShowData.jurTableVo" :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border
                      style="width: 100%" highlight-current-row :row-class-name="rowClassName" :row-style="rowStyle">
                <el-table-column type="selection" width="40" fixed="left"></el-table-column>
                <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                    <el-table-column align="center" v-if="tableValye.isShow == 1" show-overflow-tooltip :min-width="tableValye.fieldWeight" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField">
                        <template slot-scope="scope">
                            <span v-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField]
                            }}</a>
                            </span>
                            <span v-else-if="tableValye.entityField == 'createTime'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>

                            <el-tag v-else-if="tableValye.entityField == 'state'" size="mini" type="primary">
                                {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                            <span v-else-if="tableValye.fieldType == 'formatter'">
                                {{ $common.getIsGsp(tableValye.formatterContent,
                                scope.row[tableValye.entityField])
                            }}
                            </span>
                            <el-input @input="input(scope.$index, tableValye.entityField)" v-else-if="tableValye.entityField == 'availableBillMoney'" :ref="tableValye.entityField"
                                      v-model="scope.row[tableValye.entityField]" type="number" :min="0"></el-input>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>

        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" width="800px">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" />
        </el-dialog>
        <el-dialog title="登记期初采购单据发票" v-if="invoiceShow" :visible.sync="invoiceShow" width="400px">
            <el-form @submit.native.prevent inline :model="sendDataInfo" ref="sendDataInfo" class="demo-form-inline" size="mini" :show-message="false" label-width="90px">
                <el-form-item label="发票号" prop="ticketNum" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                    <el-input style="width: 270px;" clearable v-model="sendDataInfo.ticketNum"></el-input>
                </el-form-item>
                <el-form-item label="登记日期" prop="invoicingTime" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                    <el-date-picker style="width: 270px;" v-model="sendDataInfo.invoicingTime" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日" value-format="timestamp">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input style="width: 270px;" type="textarea" clearable v-model="sendDataInfo.invoiceRemark"></el-input>
                </el-form-item>
            </el-form>
            <div style="text-align: center;margin-top:20px;">
                <el-button type="primary" plain @click="initActionBox('sendDataInfo')">取消</el-button>
                <el-button type="primary" @click="sendDataAction('sendDataInfo')">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import creditApplyAction from '@/components/creditApplyAction.vue'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        creditApplyAction
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {},
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],

            pageShowData: [],
            formDataList: [],
            multipleSelection: [],
            showStatus: false,
            actionData: {},

            seId: "",
            dialogTitle: "",
            seWidth: "",
            seTitle: "",
            DialogVisible: false,
            smId: "",
            sField: "",
            parentSearchData: {},
            //-----------------------
            invoiceShow: false,
            sendDataInfo: {
                invoiceRemark: "",
                invoicingTime: "",
                ticketNum: "",
            },

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        // 表格方法
        rowClassName({ row, rowIndex }) {
            //  return "rowStyle ";
        },
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", {
                // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false,
            });
            let rowBackground = {}
            var arr = this.multipleSelection.filter(item => item.kpId == row.kpId)
            if (arr.length != 0) {
                rowBackground.backgroundColor = "#c8ffad"
            }
            return rowBackground
        },
        input(index, entityField) {
            if (this.returnData.list[index].oldAvailableBillMoney < this.returnData.list[index].availableBillMoney) {
                this.returnData.list[index].availableBillMoney = this.returnData.list[index].oldAvailableBillMoney
            } else {
                this.$set(this.returnData.list[index], 'availableBillMoney', this.$common.updataNum('availableBillMoney', this.returnData.list[index]).availableBillMoney)
                if (this.returnData.list[index].availableBillMoney == 0) {
                    this.$refs['elTable'].toggleRowSelection(this.returnData.list[index], false)
                }
            }
        },
        handleSelectionChange(val) {
            console.log(val);

            this.multipleSelection = val;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            if (type == 'salesName') {
                if (this.getRequestData.smId == undefined || this.getRequestData.smId == '') {
                    return this.$message({
                        message: "请先选择单位",
                        type: "error",
                    });
                } else {
                    this.parentSearchData.smId = this.getRequestData.smId
                }
            }
            this.sField = sField;
            this.DialogVisible = true;
            this.seId = sId;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        // 初始化赋值字段值
        initParamValue(setField) {
            let arr = setField.split(',')
            arr.forEach(item => {
                this.$set(this.getRequestData, item, "")
            })
        },
        // 清空赋值字段
        claerValue(field, pField) {
            if (this.getRequestData[field] == '') {
                this.initParamValue(pField)
            }
        },
        // 检索方案带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },

        // 子组件触发
        drawerCancel(e) {
            this.showStatus = false
            if (e == 1) this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
            this.getPageInfo()
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        

        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            });
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;
                this.getButtonList();
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList();
                this.formDataList = this.pageShowData.jurFormVoList
                this.pageShowData.jurHead && this.pageShowData.jurHead.jurconfigform.forEach((item) => {
                    item.setField && this.initParamValue(item.setField)
                })
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        clear(val) {
            if (val) {
                var arr = val.split(",")
                arr.forEach(item => {
                    this.$set(this.getRequestData, item, "")
                })
            }
        },
        // 动作集合
        actionSet(actionData) {
            console.log(actionData.actionType, 'actionData.actionType');

            switch (actionData.actionType) {
                case 0:
                    if (this.multipleSelection.length == 0) {
                        return this.$message({
                            message: "请选择数据",
                            type: "error",
                        });
                    }
                    this.sendDataInfo = {
                        invoiceRemark: '',
                        invoicingTime: new Date().getTime(),
                        ticketNum: '',
                    }
                    this.invoiceShow = true
                    break;
            }
        },
        initActionBox() {
            this.sendDataInfo = {
                invoiceRemark: '',
                invoicingTime: '',
                ticketNum: '',
            }
            this.invoiceShow = false
        },
        sendDataAction(formName) {
            var arr = []
            this.returnData.list.forEach(item => {
                if (this.multipleSelection.filter(item1 => item1.kpId == item.kpId).length > 0) {
                    arr.push(item)
                }
            })
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    const params = {
                        invoiceRemark: this.sendDataInfo.invoiceRemark,
                        invoicingTime: this.sendDataInfo.invoicingTime,
                        ticketNum: this.sendDataInfo.ticketNum,
                        klPuorerInvoiceDto: arr.map(item => {
                            return {
                                billMoney: item.availableBillMoney,
                                kpId: item.kpId,
                            }
                        })

                    }
                    const res = await this.$http.klPuordersaveInvoice(params)
                    if (res.status == 200) {
                        this.$message.success(res.message)
                        this.sendDataInfo = {
                            invoiceRemark: '',
                            invoicingTime: '',
                            ticketNum: '',
                        }
                        this.invoiceShow = false
                        this.getDataList()
                    } else {
                        this.$message.error(res.message)
                    }
                } else {
                    this.$message.error("请完善必填信息");
                    return false;
                }
            });
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.klPuorderqueryList(this.getRequestData);
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.list.forEach((item) => {
                    item.oldAvailableBillMoney = item.availableBillMoney
                })
                this.returnData.total = responseData.result.total;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
</style>